import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { MouldPerformanceAdapter } from 'src/app/models/domain/adapters/mould-performance-adapter';
import { MouldsService } from 'src/generated-clients/moulding_process';

@Injectable({
  providedIn: 'root',
})
export class MouldingProcessDataService {
  public constructor(
    private readonly mouldsApi: MouldsService,
    private readonly mouldPerformanceAdapter: MouldPerformanceAdapter
  ) {}

  public getMouldCardByEquipmentNumber(equipmentNumber: string) {
    return this.mouldsApi.apiV1MouldsMouldIdPerformanceDataGet(equipmentNumber).pipe(
      map((response) => {
        if (!response.value.mouldingProcessData) {
          throw new Error('No Data');
        }

        return this.mouldPerformanceAdapter.adaptToDomain(response.value);
      })
    );
  }
}
